import Vue from 'vue'
import Router from 'vue-router'
// import VueAnalytics from 'vue-analytics'

import LangWrapper from './views/LangWrapper'
import Menu from './views/Menu'
import Home from './views/Home'
import Azienda from './views/Azienda'
import Lavorazioni from './views/Lavorazioni'
import LavorazioniSub from './views/LavorazioniSub'
import Settori from './views/Settori'
import Contatti from './views/Contatti'
import RichiestaContatti from './views/RichiestaContatti'
import DoveSiamo from './views/DoveSiamo'
import CondizioniGenerali from './views/CondizioniGenerali'
import CookiePolicy from './views/CookiePolicy'
import Success from './views/Success'
import Failure from './views/Failure'
import NotFound from './views/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (from.name === to.name && to.hash) return

    if (from.name !== to.name && to.hash) return { selector: to.hash }

    if (savedPosition) return { savedPosition }

    return { x: 0, y: 0 }
  },
  routes: [
    // { path: '/', redirect: { name: 'it-home' } },
    {
      path: '/it/',
      component: LangWrapper,
      props: () => ({
        lang: 'it'
      }),
      children: [
        {
          name: 'it-menu',
          path: 'menu/',
          component: Menu,
          meta: {
            pageName: 'menu'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-home',
          path: '',
          component: Home,
          meta: {
            pageName: 'homepage'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-azienda',
          path: 'azienda/',
          component: Azienda,
          meta: {
            pageName: 'company'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-lavorazioni',
          path: 'lavorazioni/',
          component: Lavorazioni,
          meta: {
            pageName: 'processings'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-lavorazioni-sub',
          path: 'lavorazioni/:type/',
          component: LavorazioniSub,
          props: ({ params }) => ({ type: params.type }),
          meta: {
            pageName: 'processings/list'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-settori',
          path: 'settori/',
          component: Settori,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'sectors'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-contatti',
          path: 'contatti/',
          component: Contatti,
          meta: {
            pageName: 'contacts'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-dove-siamo',
          path: 'dove-siamo/',
          component: DoveSiamo,
          meta: {
            pageName: 'location'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-richiesta-contatti',
          path: 'richiesta-informazioni/',
          component: RichiestaContatti,
          meta: {
            pageName: 'contacts-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-condizioni-generali',
          path: 'privacy-policy/',
          component: CondizioniGenerali,
          meta: {
            pageName: 'privacy-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-cookie-policy',
          path: 'cookie-policy/',
          component: CookiePolicy,
          meta: {
            pageName: 'cookie-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-success',
          path: 'richiesta-informazioni/success/',
          component: Success,
          meta: {
            pageName: 'success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'it-failure',
          path: 'richiesta-informazioni/failure/',
          component: Failure,
          meta: {
            pageName: 'failure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          name: 'pagina-non-trovata/',
          component: NotFound,
          meta: {
            pageName: 'not-found'
          },
          pathToRegexpOptions: { strict: true }
        }
      ]
    },
    {
      path: '/',
      component: LangWrapper,
      props: () => ({
        lang: 'en'
      }),
      children: [
        {
          name: 'en-menu',
          path: 'menu/',
          component: Menu,
          meta: {
            pageName: 'menu'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-home',
          path: '',
          component: Home,
          meta: {
            pageName: 'homepage'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-azienda',
          path: 'company/',
          component: Azienda,
          meta: {
            pageName: 'company'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-lavorazioni',
          path: 'processings/',
          component: Lavorazioni,
          meta: {
            pageName: 'processings'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-lavorazioni-sub',
          path: 'processings/:type/',
          component: LavorazioniSub,
          props: ({ params }) => ({ type: params.type }),
          meta: {
            pageName: 'processings/list'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-settori',
          path: 'sectors/',
          component: Settori,
          props: ({ hash }) => ({ hash }),
          meta: {
            pageName: 'sectors'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-contatti',
          path: 'contacts/',
          component: Contatti,
          meta: {
            pageName: 'contacts'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-dove-siamo',
          path: 'location/',
          component: DoveSiamo,
          meta: {
            pageName: 'location'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-richiesta-contatti',
          path: 'contacts-request/',
          component: RichiestaContatti,
          meta: {
            pageName: 'contacts-request'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-condizioni-generali',
          path: 'privacy-policy/',
          component: CondizioniGenerali,
          meta: {
            pageName: 'privacy-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-cookie-policy',
          path: 'cookie-policy/',
          component: CookiePolicy,
          meta: {
            pageName: 'cookie-policy'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-success',
          path: 'contacts-request/success/',
          component: Success,
          meta: {
            pageName: 'success'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          name: 'en-failure',
          path: 'contacts-request/failure/',
          component: Failure,
          meta: {
            pageName: 'failure'
          },
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          name: 'pagina-non-trovata/',
          component: NotFound,
          meta: {
            pageName: 'not-found'
          },
          pathToRegexpOptions: { strict: true }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Controlla se il primo atterraggio è già stato gestito
  const isFirstVisitDone = sessionStorage.getItem('isFirstVisitDone')

  // Verifica la lingua selezionata manualmente
  const userLanguage = localStorage.getItem('selectedLanguage')

  if (!isFirstVisitDone) {
    // Marca la sessione come "prima visita già gestita"
    sessionStorage.setItem('isFirstVisitDone', 'true')

    // Se esiste già una lingua selezionata, vai direttamente a quella
    if (userLanguage) {
      if (userLanguage === 'it' && to.path === '/') {
        return next('/it/')
      }
      if (userLanguage === 'en' && to.path === '/') {
        return next()
      }
    }

    // Rileva la lingua del browser
    const browserLanguage = navigator.language || navigator.userLanguage

    // Mappa delle lingue che reindirizzano all'italiano
    const italianLanguages = ['it', 'it-IT', 'it-CH']

    // Se la lingua del browser è italiana, reindirizza la root in '/it/'
    if (italianLanguages.includes(browserLanguage) && to.path === '/') {
      return next('/it/')
    }

    // Se la lingua del browser è inglese o altro, resta su '/'
    if (to.path === '/') {
      return next()
    }
  }

  // Se NON è il primo atterraggio, rispetta la lingua selezionata manualmente
  if (userLanguage) {
    if (userLanguage === 'it' && to.path === '/') {
      return next('/it/')
    }
    if (userLanguage === 'en' && to.path === '/') {
      return next()
    }
  }

  // Procede normalmente alla rotta richiesta
  next()
})

export default router
